import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'


class Tooltip extends Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        return (
            <span>
                <i className="fa fa-info-circle infoIcon" data-tip={this.props.Description}></i>
                <ReactTooltip place="right" type="info" effect="float" />
            </span>
        );
    }
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip.js